export default __webpack_public_path__ + "static/media/fad-logo-protools.fdcc35cb.svg";